module.exports = __webpack_public_path__ + "media/images/smart_phone/e_friends-dd84e27eabcb4636279fc87ec15b88a7.jpg";